import Institution from './institution-list';
import InstitutionDetail from './institution-detail';

export { Institution, InstitutionDetail };
